import React from 'react';
import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '../../constants/blogPosts';
import { PostCard } from '../blog/BlogLayout';
import { NewsletterSignup } from '../blog/NewsletterSignup';

export const BlogSection = ({ openPrivacyPolicy }) => (
  <section id="blog" className="py-16 sm:py-24 bg-gradient-to-b from-white to-sand-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-3xl mx-auto mb-12 space-y-4">
        <div className="inline-block px-4 py-2 bg-gold-100 border border-gold-300 rounded-full">
          <span className="text-sm font-semibold text-[#143160]">Coastal Insights</span>
        </div>
        <h2 className="text-4xl sm:text-5xl font-serif text-neutral-900">From The Blog</h2>
        <p className="text-lg text-neutral-600">Market updates, buyer &amp; seller tips, and coastal lifestyle stories from Hampton Roads to the Outer Banks.</p>
      </div>
      <div className="grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-6" data-testid="blog-posts-grid">
          {BLOG_POSTS.slice(0, 3).map((post, i) => <PostCard key={post.slug} post={post} large={i === 0} />)}
          <Link to="/blog" data-testid="blog-view-all" className="inline-flex items-center font-bold text-[#143160] hover:text-gold-600">View all posts →</Link>
        </div>
        <aside className="lg:col-span-1">
          <NewsletterSignup openPrivacyPolicy={openPrivacyPolicy} />
        </aside>
      </div>
    </div>
  </section>
);
